import { useContext, useEffect } from 'react'
import { UnsavedChangesContext, type UnsavedChangesContextValue } from '@/shared/lib/unsavedChangesContext'

export const useUnsavedChanges = (): UnsavedChangesContextValue => {
  const value = useContext(UnsavedChangesContext)
  if (!value) {
    throw new Error('useUnsavedChanges must be used within UnsavedChangesProvider')
  }

  return value
}

export const useUnsavedChangesOptional = (): UnsavedChangesContextValue | null =>
  useContext(UnsavedChangesContext)

export const useRegisterUnsavedChanges = (dirty: boolean) => {
  const { setDirty } = useUnsavedChanges()

  useEffect(() => {
    setDirty(dirty)
  }, [dirty, setDirty])

  useEffect(() => {
    return () => setDirty(false)
  }, [setDirty])
}

